import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { get } from 'lodash';
import { Controller } from 'react-hook-form';

const CustomTextInput = ({
  control,
  name,
  label,
  errors,
  helperText,
  type = 'text',
  placeholderText = '',
  readOnly,
  disabled,
  adornment,
  ...rest
}) => {
  const errorMessage = get(errors, name, {})?.message;
  const combinedHelperText = [helperText, errorMessage].filter(Boolean).join(' * ');

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          type={type}
          data-testid={name}
          label={label}
          variant="outlined"
          fullWidth
          error={!!errorMessage}
          helperText={combinedHelperText}
          placeholder={placeholderText}
          disabled={disabled}
          slotProps={{
            input: {
              readOnly: readOnly,
              ...(adornment ? { endAdornment: <InputAdornment position="end">{adornment}</InputAdornment> } : {}),
            },
            inputLabel: {
              shrink: !!field.value || field.value === 0,
            },
          }}
          {...rest}
        />
      )}
    />
  );
};

export default CustomTextInput;
